'use client';

import { X } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';

export function ErrorPopup() {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <>
      {/* MUI Snackbar z-index and ErrorPopup shadow; packages/ui/src/DynamicWithRetry/ErrorPopup.tsx. */}
      <div className="fixed top-0 left-1/2 z-[1400] flex w-full -translate-x-1/2 justify-center px-2 pt-4 md:pt-1">
        <div
          className="flex items-center rounded border-l-4 border-destructive bg-background py-2 pr-2 pl-5 shadow-[0_1px_3px_0_rgb(0_0_0_/_30%)] sm:py-3"
          role="alert"
        >
          <Image
            className="self-start"
            width={24}
            height={24}
            src="https://www.nerdwallet.com/cdn/wealth/icons/alert-red.svg"
            alt="Error Alert"
            unoptimized
          />
          <p className="typography-text-small pl-2 sm:whitespace-nowrap">
            Something went wrong. Please refresh the page.
          </p>
          <button
            className="typography-text-small ml-1 px-3 font-medium text-[var(--content-red-dark)] focus-visible:focus-ring"
            onClick={() => {
              setOpen(false);
              window.location.reload();
            }}
            type="button"
          >
            Refresh
          </button>
          <button
            aria-label="Close error message"
            className="px-1 text-[var(--content-neutral-dark)] focus-visible:focus-ring"
            onClick={() => setOpen(false)}
            type="button"
          >
            <X aria-hidden size={20} />
          </button>
        </div>
      </div>
    </>
  );
}
